import * as React from "react";
import {
    IImageWithOverlayOptions,
    ImageWithOverlay,
} from "../../../../presentation/Shared/Image/ImageWithOverlay";

export function BannerImage({
    bannerImage,
    columnCount,
}: {
    bannerImage: IBannerImage;
    columnCount: number;
}) {
    const imageOptions: IImageWithOverlayOptions = {
        imageLabel: bannerImage.imageLabel,
        imageUrl: bannerImage.imageUrl,
        imageCSS: {
            position: `absolute`,
            left: columnCount == 2 ? `123px` : `calc(50% - 40px)`,
            top: `-38px`,
            zIndex: -1,
            filter: bannerImage.imageFilter,
            maskImage: `linear-gradient(
                to bottom,
                black 0%,
                black 42%,
                rgba(0, 0, 0, 0.45) 64%,
                transparent 82%
            )`,
            WebkitMaskImage: `linear-gradient(
                to bottom,
                black 0%,
                black 42%,
                rgba(0, 0, 0, 0.45) 64%,
                transparent 82%
            )`,
        },
        imageWidth: 80,
        imageHeight: 80,
    };

    return <ImageWithOverlay options={imageOptions} />;
}

export const BannerImages = {
    barbute: {
        imageLabel: `barbute`,
        imageUrl: "/images/icons/barbute.svg",
        imageFilter: `saturate(0.4) hue-rotate(60deg) opacity(0.7)`,
    },
    cherish: {
        imageLabel: `cherish`,
        imageUrl: "/images/icons/cherish.svg",
        imageFilter: `saturate(0.4) hue-rotate(2deg) opacity(0.5) brightness(1.3)`,
    },
    flagTrumpet: {
        imageLabel: `flagTrumpet`,
        imageUrl: "/images/icons/trumpet-flag.svg",
        imageFilter: `saturate(0.4) hue-rotate(236deg) opacity(0.7)`,
    },
    starsStack: {
        imageLabel: `starsStack`,
        imageUrl: "/images/icons/stars-stack.svg",
        imageFilter: `sepia(0.8) hue-rotate(39deg) saturate(2.3)`,
    },
    waxTablet: {
        imageLabel: `waxTablet`,
        imageUrl: "/images/icons/wax-tablet.svg",
        imageFilter: `sepia(0.8) hue-rotate(32deg) brightness(1.2) saturate(2.2)`,
    },
    fire: {
        imageLabel: `fire`,
        imageUrl: "/images/icons/fire.svg",
        imageFilter: `sepia(0.6) hue-rotate(0deg) brightness(0.7) saturate(2)`,
    },
    minerals: {
        imageLabel: `minerals`,
        imageUrl: "/images/icons/minerals.svg",
        imageFilter: `sepia(0.6) hue-rotate(7deg) brightness(0.9) saturate(2) brightness(1.4)`,
    },
    target: {
        imageLabel: `target`,
        imageUrl: "/images/icons/target.svg",
        imageFilter: `sepia(2) hue-rotate(34deg) brightness(0.9) saturate(2.3) brightness(0.5)`,
    },
};

export interface IBannerImage {
    imageLabel: string;
    imageUrl: string;
    imageFilter?: string;
}
